import { getScribeHttpClients } from '@heidi/api/client';
import { type components } from '@heidi/schema/ml-scribe';

import {
  type SnippetsResponse,
  type SnippetsUploadResponse,
  type VerbalTriggerIntent,
} from '../../contracts';

type SingleSnippetResponse = components['schemas']['SingleSnippetResponse'];

const scribeHttpV2 = () => getScribeHttpClients().scribeHttpV2;

export function verbalTriggerToWireFields(intent: VerbalTriggerIntent | undefined) {
  if (!intent || !intent.enabled) return {};
  return { trigger_phrase: intent.phrase, is_verbal_trigger: true };
}

/** @domain workspace */
export const createUserSnippet = (input: {
  shorthand: string;
  content: string;
  verbalTrigger?: VerbalTriggerIntent;
}) => {
  const { shorthand, content, verbalTrigger } = input;
  return scribeHttpV2().post<SingleSnippetResponse>(`/snippets`, {
    shorthand,
    content,
    ...verbalTriggerToWireFields(verbalTrigger),
  });
};

/** @domain workspace */
export const createUserSnippetsBatch = (input: {
  snippets: {
    shorthand: string;
    content: string;
    verbalTrigger?: VerbalTriggerIntent;
  }[];
}) => {
  return scribeHttpV2().post<SnippetsResponse>(`/snippets/batch`, {
    snippets: input.snippets.map(({ shorthand, content, verbalTrigger }) => ({
      shorthand,
      content,
      ...verbalTriggerToWireFields(verbalTrigger),
    })),
  });
};

// Upload CSV to create snippets in batch
/** @domain workspace */
export const uploadSnippetsBatchCsv = (file: File) => {
  const formData = new FormData();
  formData.append('file', file);

  return scribeHttpV2().post<SnippetsUploadResponse>(`/snippets/batch/upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};
